import {
    type silentlyGetResourceTokenFunc,
    type promptForResourceTokenFunc,
    type silentlyGetStrongConsumerAuthFunc,
    type promptForStrongConsumerAuthFunc,
    type getLoginHintClaimFunc,
    type setLoginHintClaimFunc,
    type deleteLoginHintClaimFunc,
} from './authCallbacks';

// AuthenticationConfig is a configuration object that allows the caller to provide custom
// implementations for common authentication tasks. Instead of hanging things off of the serviceConfig,
// specialized authentication tasks can be provided here.

export interface AuthenticationConfig {
    promptForResourceToken?: promptForResourceTokenFunc;
    silentlyGetResourceToken?: silentlyGetResourceTokenFunc;
    promptForStrongConsumerAuth?: promptForStrongConsumerAuthFunc;
    silentlyGetStrongConsumerAuth?: silentlyGetStrongConsumerAuthFunc;
    signoutFromOwa?: () => Promise<void>;
    getLoginHintClaim?: getLoginHintClaimFunc;
    setLoginHintClaim?: setLoginHintClaimFunc;
    deleteLoginHintClaim?: deleteLoginHintClaimFunc;
    // Add new methods here. Currently not for use with the DataWorker
}

let currentAuthConfig: AuthenticationConfig = {};

export function getAuthConfig(): AuthenticationConfig {
    return currentAuthConfig;
}

export function updateAuthConfig(authConfig?: Partial<AuthenticationConfig>): void {
    currentAuthConfig = { ...currentAuthConfig, ...authConfig };
}
